<template>
  <div class="card" :class="[`card--${size}`]">
    <div class="card-top">
      <img v-if="cardinfo.icon" class="card-top-icon" :src="cardinfo.icon" />
      <div v-else class="card-top-default-icon"></div>
      <div class="card-top-text" :style="{ color: `${fontColor}` }">
        {{ cardinfo.text }}
      </div>
      <div v-if="showRightArrow" class="card-top-arrow"></div>
    </div>
    <template v-if="cardinfo.labelInfo">
      <div v-if="!Array.isArray(cardinfo.labelInfo)" class="card-text">
        {{ cardinfo.labelInfo }}
      </div>
      <div
        v-else-if="cardinfo.labelInfo.length"
        ref="promotions"
        class="card-promotions"
      >
        <div class="card-promotions-list">
          <div
            v-for="(item, index) in cardinfo.labelInfo"
            :key="index"
            class="card-promotions-list-item"
          >
            <div class="card-promotions-list-item-text">{{ item }}</div>
          </div>
        </div>
        <div
          v-if="showArrow"
          class="card-promotions-arrow"
          @click.stop.prevent="switchArrow"
        >
          <div :class="['card-promotions-arrow-item', promotionsArrow]"></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    cardinfo: {
      type: Object,
      default: () => {},
    },
    fontColor: {
      type: String,
      default: '#222222',
    },
    showRightArrow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal', // 'normal' | 'large'
      validator: (value) => ['normal', 'large'].includes(value),
    },
  },
  data() {
    return {
      showArrow: false,
      promotionHeight: 0,
      labelHeight: 0,
      showAllLabel: false,
    }
  },
  computed: {
    promotionsArrow() {
      return this.showAllLabel ? 'up' : 'down'
    },
  },
  watch: {
    'cardinfo.labelInfo': function() {
      this.$nextTick(() => {
        this.adjustPromotion()
      })
    },
  },
  created() {},
  mounted() {
    this.adjustPromotion()
  },
  methods: {
    adjustPromotion() {
      this.promotionHeight = this.$refs?.promotions?.offsetHeight
      this.labelHeight =
        document.querySelector('.card-promotions-list-item')?.offsetHeight + 3
      if (this.promotionHeight > this.labelHeight) {
        this.showArrow = true
        this.$refs.promotions.firstElementChild.style.maxHeight = `${this.labelHeight}px`
      }
    },
    switchArrow() {
      if (!this.showAllLabel) {
        this.$refs.promotions.firstElementChild.style.maxHeight = `${2 *
          this.labelHeight}px`
        this.showAllLabel = true
      } else {
        this.$refs.promotions.firstElementChild.style.maxHeight = `${this.labelHeight}px`
        this.showAllLabel = false
      }
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 260px;
  padding: 19px 0 18px;
  &-top {
    .flex-center(space-between);
    width: 100%;
    &-icon {
      width: 18px;
      height: 18px;
    }
    &-default-icon {
      width: 22px;
      height: 22px;
      background: rgba(0, 0, 0, 0.06);
      border-radius: 3px;
    }
    &-text {
      margin-left: 8px;
      font-family: PingFang SC, sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: #111111;
      line-height: 20px;
      text-align: left;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &-arrow {
      height: 22px;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-shrink: 0;
      margin-left: auto;

      &::after {
        content: '';
        width: 11px;
        height: 11px;
        background-image: url('~@/assets/img/guide_arrow@3x.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  // 🟩 【新增】大尺寸样式（用于付款码页面）
  &--large {
    .card-top {
      &-icon {
        width: 22px;
        height: 22px;
      }
      &-default-icon {
        width: 22px;
        height: 22px;
      }
      &-text {
        font-size: 15px;
        line-height: 22px;
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .card-promotions {
      margin-left: 32px;
    }
  }
  &-text {
    .font-area(12px);
    line-height: 16px;
    font-weight: 400;
    margin-left: 26px;
    margin-top: 2px;
    font-family: PingFangSC-Regular;
    color: #999999;
    letter-spacing: 0;
    text-align: left;
  }
  &-promotions {
    margin-top: 1px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-left: 26px;
    width: 207px;
    &-list {
      .flex-center(flex-start);
      width: 160px;
      flex-wrap: wrap;
      overflow-y: hidden;
      &-item {
        border-radius: 3px;
        background: transparent;
        border: 0.5px solid #FFC6C1;
        padding: 0 4px;
        margin: 2px 3px 0 1px;
        height: auto;
        &-text {
          font-family: PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 11px;
          color: #FF2D19;
          line-height: normal/2;
          text-align: left;
          .text-hide(150px);
        }
      }
    }
    &-arrow {
      width: 36px;
      height: 19px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      &-item {
        margin-top: 8px;
        margin-right: 30px;
        width: 6px;
        height: 4px;
      }
    }
  }
}
.up {
  .bg-img(url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAHBJREFUCB1jYEACs2bNip03b54skhADI4wDlKz5//9/EJDPBcRu6enpj0ByTCACKukEZNowMTGVA+ldM2fOlAPJMQIly4E63YFsH6CubyDB2bNn+//796+Tk5PTGMTR3L9/PwtIAhnMnz9fYdu2bewARzcrXv+XlnsAAAAASUVORK5CYII=));
}
.down {
  .bg-img(
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAGBJREFUCB1jnDlz5lomJqZFqampGxmgACjGxcjIuJGZmTmeCShW+O/fv87Zs2f7g+RBkkBqCxAfTE5OfsYIFZQD0ruAJjUCFacCde9LS0trAcmBFSAp2geUXACTBIkTBADB1yFkbRGFVAAAAABJRU5ErkJggg==)
  );
}
</style>
